import React, { Component } from 'react'
import AdminDashboard from './adminDashboard'

class AdminCampaign extends Component {
    constructor(props) {
        super(props)

        this.state = {
                 
        }
    }

    render() {
        return (
            <AdminDashboard>
                <h1>Admin Campaign</h1>
            </AdminDashboard>
        )
    }
}

export default AdminCampaign
